import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

// Gerçek 404 sayfası — soft-404 yerine. Arama motorlarına noindex verilir.
export default function NotFound() {
  return (
    <div
      data-testid="not-found-page"
      className="flex min-h-[60vh] flex-col items-center justify-center px-4 py-24 text-center"
    >
      <Helmet>
        <title>Sayfa Bulunamadı | Ertan Kasap</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <span className="font-mono text-7xl font-bold text-bordo sm:text-8xl">404</span>
      <h1 className="mt-5 font-serif text-3xl text-cream sm:text-4xl">Aradığınız sayfa bulunamadı</h1>
      <p className="mt-4 max-w-md text-base leading-relaxed text-cream/60">
        Sayfa taşınmış ya da hiç var olmamış olabilir. Ana sayfadan gezinmeye devam edebilirsiniz.
      </p>
      <Link
        to="/"
        data-testid="not-found-home-link"
        className="mt-8 inline-flex min-h-[44px] items-center gap-2 rounded-sm bg-bordo px-7 py-3.5 text-sm font-bold uppercase tracking-wide text-cream transition-colors hover:bg-bordo-dark"
      >
        Ana Sayfaya Dön
      </Link>
    </div>
  );
}
